import { Injectable } from '@angular/core';
import { Step } from './step';
import { Meta } from './meta';
import * as JSZip from 'jszip';
import { slugify } from './utils';
import { saveAs } from 'file-saver/FileSaver';
import { GithubManagerService } from './github-manager.service';
import { HttpClient } from '@angular/common/http';

let INFO:any = {
	"machines": new Set<string>([
		"vinylcutter",
		"milling-machine",
		"lasercutter",
		"3dprinter",
	]),
	"tools": new Set<string>([
		"wrench",
		"screwdriver",
		"screw",
		"scissors",
		"saw",
		"ruler",
		"pliers",
		"pincers",
		"nail",
		"micro-controller",
		"hot-glue",
		"helmet",
		"hammer",
		"drill",
		"cutter",
		"compass",
		"clamp",
		"caliber",
		"brush",
	]),
	"topics": [
		"project-management",
		"electronics-production",
		"computer-controlling-machining",
		"computer-controlled-cutting-vinyl",
		"computer-controlled-cutting-laser",
		"3d-printing",
		"3d-drawing",
		"2d-drawing",
  ],
	"skills": new Set<string>([
		"git",
		"electronics",
		"3d",
		"2d",
	])
}; 


@Injectable()
export class DocsService {

  meta: Meta = {} as Meta;
  tools: Set<string> = INFO.tools;
  machines: Set<string> = INFO.machines;
  skills: Set<string> = INFO.skills;
  topics: string[] = INFO.topics;

  constructor(
    private http: HttpClient
  ) {

    let data = this.load();
    if (data === null) {
      this.meta = {
        level: 3,
        time: 90,
        cost: 1,
        steps: [],
        tools: new Set([]),
        skills: new Set([]),
        machines: new Set([]),
      } as Meta;
    } else {
      this.meta = data;
    }
    console.log(this.machines);
  }

  save() {
    let toStore:any  = Object.assign({}, this.meta);
    toStore.tools = Array.from(this.meta.tools);
    toStore.skills = Array.from(this.meta.skills);
    toStore.machines = Array.from(this.meta.machines);
    localStorage.setItem('meta', JSON.stringify(toStore));
  }

  load() {
    let stored:any = JSON.parse(localStorage.getItem('meta'));
    if (stored) {
      stored.tools = new Set(stored.tools);
      stored.skills = new Set(stored.skills);
      stored.machines = new Set(stored.machines);
    }
    return stored as Meta;
  }

  addStep() {
    this.meta.steps.push( {
      title: '',
      description: '',
      image: undefined,
      time: 5,
      helpWanted: false,
    } as Step)
  }

  license() {
    let lic = 'CC-';
    if (!this.meta.isCommercial) {
      lic += 'NC-';
    }
    lic += 'BY-SA';
    return lic;
  }

  availableItems(items_type: string) {
    let ret = new Set(
      Array.from(this[items_type]).filter( x => !this.meta[items_type].has(x) )
    );
    return ret;
  }

  usedItems(items_type: string) {
    return this.meta[items_type];
  }

  addItem(items_type: string, item) {
    this.meta[items_type].add(item);
  } 

  removeItem(items_type: string, item) {
    this.meta[items_type].delete(item);
  }

  private step2text(step: Step, index: number) {
    let help = '';
    if (step.helpWanted) {
      help = `
<div class="help" markdown="1">

<h1 class="helpTitle">Help wanted</h1>

${step.helpDescription}

</div>
      
`
    }
    let data = `
<div class="step">
<div class="info">
<img class="img-resp" src="./images/img_${index}.png">
</div>
<div class="description">
<div class="main"  markdown="1">
<h2 class="title"> <span> Step ${index + 1}</span> ${step.title} </h2>
<div class="time"> Time: ${step.time} mins </div>

${step.description}

</div>

${help}

</div>

</div>

`
    return data;
  }

  private meta2text() {
    if (!this.meta.date) {
      this.meta.date = new Date().toISOString().substring(0, 10);
    }
    

    let data = `---
layout: tutorial
num: ${this.meta.id}
title: ${this.meta.title}
description: "${this.meta.brief}"
image: /tutorials/${this.folderGen()}/images/main.png
level: ${this.meta.level}
time: ${this.buildTime()}
cost: ${this.meta.cost}
data: ${this.meta.date}
tools: [${Array.from(this.usedItems('tools')).map(tool => `'${tool}'`)}]
machines: [${Array.from(this.usedItems('machines')).map(tool => `'${tool}'`)}]
skills: [${Array.from(this.usedItems('skills')).map(tool => `'${tool}'`)}]
license: "${this.license()}"
topic: ${this.meta.topic}`

if (this.meta.youtube) {
  data += `
youtube: ${this.meta.youtube}`
} 

data += `
---

${this.meta.description}

# What I need to build it?

${this.meta.materials}
`



    return data;
  }

  private closingToText() {
    return `
<div class="contributors" markdown="1">

# Contributors

${this.meta.credits}

</div>
    `
  } 

  toText() {
    let data = this.meta2text();
    for (let i = 0; i< this.meta.steps.length; i++) {
      let step = this.meta.steps[i];
      data += this.step2text(step, i);
    }
    data += this.closingToText()

    return data;
  }

  folderGen() {
    return this.meta.date + "-" + slugify(this.meta.title);
  }

  downlaod() {
    this.save();
    let zip: JSZip = new JSZip();
    zip.file("index.md",this.toText());
    var img = zip.folder("images");
    img.file("main.png", this.meta.image.split(',')[1], {base64: true});
    this.meta.steps.forEach( (step, idx) => {
      img.file("img_"+idx+".png", step.image.split(',')[1], {base64: true})
    });
    zip.file("data.json",JSON.stringify(this.meta));

    zip.generateAsync({type:"blob"})
    .then((content) => {
        saveAs(content, this.folderGen() +".zip");
    });
  }

  buildTime() {
    return this.meta.steps.map(step => step.time).reduce(
      (acc, t) => acc + t, 0
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/docs.service.ts